export default function ExplistModule(element) {

    let swiperElm = element.querySelector('.swiper');
    
    const swiper = new Swiper(swiperElm, {
        // configure Swiper to use modules
        // slidesPerGroup: 1,
        slidesPerView: 1.5,
        spaceBetween: 20,
        mousewheel: {
            forceToAxis:true,
        },
        // width: 1360,
        // centeredSlides: true,
        // centeredSlidesBounds: true,
        pagination: { 
            el: element.querySelector('.swiper-pagination'), 
            clickable: true,
        },
        autoplay: {
            delay: 5000,
        },
        // navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev',
        // },
        breakpoints	: {
            991: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 40,
            },
            767: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 20,
            }
        }
    });


    return this;
}


window.modules = window.modules || {}
window.modules.ExplistModule = ExplistModule;
